import { extendDeep } from '../../utils/utils';
import { initItem } from './item';
import { defaultSettings } from './settings';
import { initFolders } from './folders';
import { initItems } from './items';
import { initHttp } from '../../utils/http';
import { addEvents } from '../decorators';
import { eventsList } from '../../events/list';
export function Dropbox(userSettings) {
  if (userSettings === void 0) {
    userSettings = {};
  }
  this.siteMediaToken = userSettings.siteMediaToken;
  const settings = extendDeep(defaultSettings, userSettings);
  const http = initHttp();
  const folders = initFolders(settings, http);
  const items = initItems(settings, http);
  const item = initItem(settings, http);
  this.name = 'dropbox';
  this.folders = addEvents(this, eventsList.FOLDERS, folders);
  this.items = addEvents(this, eventsList.ITEMS, items);
  this.item = addEvents(this, eventsList.ITEM, item);
}